import { useDispatch, useSelector } from 'react-redux';

import { OperatorField } from './OperatorField';
import { OperatorsActions } from '../../store/reducers/operators';
import RadioGroup from '../common/RadioGroup';
import Radio from '../common/Radio';
import { DISABLED, ENABLED } from '../../constants/permissions';

export function OperatorAutoSync() {
  const dispatch = useDispatch();

  const {
    configuration: { autoSync },
  } = useSelector((state) => state.operators);

  const setAutoSync = (autoSync) => {
    dispatch({ type: OperatorsActions.configuration, payload: { autoSync } });
  };

  return (
    <OperatorField
      title="Product Listing"
      description={
        `If enabled, and product integration is included in the operator's contract, ` +
        `the seller's products will be automatically injected (without any manual approval processes) ` +
        `into the operator's platform, mapped according to the operator's taxonomy.`
      }
    >
      <RadioGroup
        name="auto-sync"
        onChange={(value) => setAutoSync(value === ENABLED)}
        selectedvalue={autoSync ? ENABLED : DISABLED}
      >
        <Radio id="autosync_enabled" value={ENABLED} label="Enabled" />
        <Radio id="autosync_disabled" value={DISABLED} label="Disabled" />
      </RadioGroup>
    </OperatorField>
  );
}
